import { Box, BoxProps } from '@mui/material';
import { usePressedState } from 'Utils/usePressedState';

/**
 * A Box that shows it is pressed (see usePressedState), for clickables
 * rendered in a list, where a hook cannot be called per item.
 */
const PressableBox = ({ sx, children, ...rest }: BoxProps) => {
  const { pressedSx, pressHandlers } = usePressedState();
  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx]), pressedSx]} {...pressHandlers} {...rest}>
      {children}
    </Box>
  );
};

export default PressableBox;
